/*
This component is matched with the nunjucks locale-switcher-header component.
Every change made in this component should be checked and updated (if necessary) in its matching component and viceversa.
*/

import { useState, useEffect } from "preact/hooks";
import { useSignalEffect } from "@preact/signals";
import { html } from "htm/preact";
import { openId } from "./state.js";
import { setLocaleCookie } from "../utils/utils.js";

export default function LocaleSwitcherHeader({
  lang,
  locales,
  pages
}) {
  const [open, setOpen] = useState(false);

  useSignalEffect(() => {
    if (openId.value !== "locale-switcher-header") {
      setOpen(false)
    }
  })

  const langBtnFunc = function () {
    const header = document.querySelector("#header");
    const mobileBtn = document.getElementById("nav-button-mobile-island");
    const mobile = mobileBtn.checkVisibility();
    if (open) {
      openId.value = "";
      setOpen(false);
      if (mobile) {
        header.removeAttribute("data-nav-mobile-open");
      }
    } else {
      openId.value = "locale-switcher-header";
      setOpen(true);
      header.removeAttribute("data-nav-open");
      if (mobile) {
        header.setAttribute("data-nav-mobile-open", "");
      }
    }
  };

  function getLanguage() {
    for (const locale of locales) {
      if (locale.code == lang) {
        return `${locale.label}`
      }
    }
  }

  useEffect(() => {
    const header = document.querySelector("#header");
    const mobileBtn = document.getElementById("nav-button-mobile-island");
    const mobile = mobileBtn.checkVisibility();
    const isOpen = header.hasAttribute(mobile ? "data-nav-mobile-open" : "data-nav-open");

    const handleOutsideClick = (event) => {
      if (!header.contains(event.target) && isOpen && mobile){
        header.removeAttribute("data-nav-mobile-open");
        openId.value = "";
      }
    }

    document.addEventListener("click" , handleOutsideClick)
  })

  useEffect(() => {
    const nav = document.querySelector("[data-locale-switcher-header]");
    
    if (nav) {
      if (open) {
        nav.setAttribute("data-active", "");
      } else {
        nav.removeAttribute("data-active");
      }
    }
  }, [open])

  const handleLocaleChange = (e, localeCode, url) => {
    e.preventDefault();
    setLocaleCookie(localeCode);
    window.location.href = url;
  };

  return html`
    <div
    role="button"
    class="locale-switcher-button relative z-20 px-3 py-2 inline-flex items-center gap-x-1 leading-6 rounded-lg border border-transparent bg-transparent cursor-pointer group-data-active:border-olive-500/20 group-data-active:bg-olive-500/10 group-data-hero-outside:bg-olive-50 group-data-active:rounded-t-lg group-data-active:rounded-b-none"
    id="locale-button-header"
    onclick=${langBtnFunc}
    title="{{ i18n.ui.change_locale[lang] }}">
    <span class="sr-only">${lang}</span>
    <svg width="16" height="16" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" role="img" fill="none" class="size-5 stroke-2 stroke-current lg:size-4" aria-hidden="true">
      <circle cx="24" cy="24" r="23" stroke-linejoin="round"></circle>
      <path d="M23 1C23 1 15 10.4901 15 24C15 37.5099 23 47 23 47" stroke-linejoin="round"></path>
      <path d="M25 1C25 1 33 10.4901 33 24C33 37.5099 25 47 25 47" stroke-linejoin="round"></path>
      <path d="M1 24H47"></path>
    </svg>
    <div class="inline-flex items-center gap-x-1">
      <span class="ml-1">${getLanguage()}</span>
      <svg id="locale-button-caret-header" class="h-4 w-4 flex-none transition-transform group-data-active:rotate-180" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="1">
        <path d="M5.5 7.5l4.493 5 4.507-5" fill="none" stroke="currentColor"/>
      </svg>
    </div>
  </div>

  <div
    class="locale-switcher-menu invisible opacity-0 bg-olive-50 group-data-hero/root:bg-transparent group-data-hero-outside:bg-olive-50 group-data-active:visible group-data-active:opacity-100 left-0 top-full absolute z-10 w-full origin-top-left rounded-b-lg rounded-t-none border border-t-0 border-olive-500/20 focus:outline-none"
    role="menu"
    aria-orientation="vertical"
    aria-labelledby="locale-button-header"
    tabindex="-1">
    <div class="flex flex-col gap-1 p-2 text-m leading-6" role="none">
        
      ${Object.values(pages).map(page => {
  const locale = locales.find(l => l.code === page.lang);
  return page ? html`
    <div key=${page.lang}>
      <a 
        href=${page.url}
        onclick=${(e) => handleLocaleChange(e, page.lang, page.url)}
        title=${locale?.label}
        lang=${page.lang}
        class="transition-colors flex px-2 py-1.5 select-none text-sm rounded-md hover:bg-olive-500/10"
      >
        ${locale?.label}
      </a>
    </div>` : null;
})}  
        
    </div>

  </div>
  `;

}
